import { Link } from "react-router-dom";
import './footer.css'
import logoTwo from '../../assets/images/logo-two.png'
import footerShape from '../../assets/images/footer-shape.png'

const Footer = () => {
    return (
        <>
            {/* <!-- Start Footer Area --> */}
            <div className="footer-area pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-sm-12 col-md-12">
                            <div className="footer-widget" >
                                <a href="/">
                                    <img src={logoTwo} alt="images" />
                                </a>
                                <p>Lorem ipsum dolor sit amet cons elit sed doeiusm
                                    tempor incididunt ut labore et do magna aliqua enim
                                    minimLorem ipsum dolor sit amet cons elit sed
                                    eiusmod tempor incididunt.</p>
                                <ul className="souile-footer-widget-list">
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="col-lg-4 col-sm-6 col-md-4">
                                    <div className="footer-widget footer-left-widget" >
                                        <h2>Our Services</h2>
                                        <ul className="list-widget">
                                            <li>
                                                <Link to="/services-detail"><i className='bx bx-arrow-back' ></i>Carpet Cleaning</Link>
                                            </li>
                                            <li>
                                                <Link to="/services-detail"><i className='bx bx-arrow-back' ></i>Plumbing Services</Link>
                                            </li>
                                            <li>
                                                <Link to="/services-detail"><i className='bx bx-arrow-back' ></i>Home Cleaning</Link>
                                            </li>
                                            <li>
                                                <Link to="/services-detail"><i className='bx bx-arrow-back' ></i>Office Services</Link>
                                            </li>
                                            <li>
                                                <Link to="/services-detail"><i className='bx bx-arrow-back' ></i>Glass Cleaning</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-md-4">
                                    <div className="footer-widget footer-left-two-widget">
                                        <h2>Explore</h2>
                                        <ul className="list-widget">
                                            <li>
                                                <Link to="/about"><i className='bx bx-arrow-back' ></i>About Us</Link>
                                            </li>
                                            <li>
                                                <Link to="/contact"><i className='bx bx-arrow-back' ></i>Contact Us</Link>
                                            </li>
                                            <li>
                                                <Link to="/services"><i className='bx bx-arrow-back' ></i>Our Services</Link>
                                            </li>
                                            <li>
                                                <Link to='/terms'><i className='bx bx-arrow-back'></i>Terms & Policy</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-md-4">
                                    <div className="footer-widget footer-left-three-widget" >
                                        <h2>Contact</h2>
                                        <div className="widget-contact-list">
                                            <div className="notification-icon">
                                                <i className="flaticon-phone-call"></i>
                                            </div>
                                            <a href="tel:+923061922327">+923061922327</a>
                                        </div>
                                        <div className="widget-contact-list bgs-bottom">
                                            <div className="notification-icon">
                                                <i className="flaticon-email"></i>
                                            </div>
                                            <a href="mailto:usama@thejunestore.com"><span className="__cf_email__" >usama@thejunestore.com</span></a>

                                        </div>
                                        <div className="widget-contact-list bgs-bottom-12">
                                            <div className="notification-icon">
                                                <i className="flaticon-pin"></i>
                                            </div>
                                            <p>Lahore, Pakistan</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-shape-1" >
                    <img src={footerShape} alt="images" />
                </div>
            </div>
            {/* <!-- End Footer Area --> */}

            {/* <!-- Start Back Bottom --> */}
            <div className="go-top">
                <i className='bx bx-chevrons-up'></i>
            </div>
            {/* <!-- End  Back Bottom --> */}

        </>
    )
}

export default Footer